class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        const content = wrapper.querySelector('.product-recommendations');
        if (content) {
          this.replaceWith(content);
        } else {
          this.remove();
        }
      })
      .catch(() => this.remove());
  }
}

customElements.define('product-recommendations', ProductRecommendations);
